import { ClientEnrichmentStatusRequest, ClientEnrichmentStatusResponse } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchEnrichmentStatus() {
  const [fetching, setFetching] = useState(false);
  const [status, setStatus] = useState<ClientEnrichmentStatusResponse>();

  async function fetchEnrichmentStatus(params: ClientEnrichmentStatusRequest) {
    try {
      setFetching(true);
      const res = await api.fetchClientEnrichmentStatus(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setStatus(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, status, fetchEnrichmentStatus };
}
